import { render, staticRenderFns } from "./GnbQuickMenu.vue?vue&type=template&id=2f570bbc"
import script from "./GnbQuickMenu.ts?vue&type=script&lang=ts&external"
export * from "./GnbQuickMenu.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports